import { render, staticRenderFns } from "./line.vue?vue&type=template&id=2624f552&scoped=true&"
import script from "./line.vue?vue&type=script&lang=js&"
export * from "./line.vue?vue&type=script&lang=js&"
import style0 from "./line.vue?vue&type=style&index=0&id=2624f552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624f552",
  null
  
)

component.options.__file = "line.vue"
export default component.exports